import { isAnyUndefined } from "../panels/panelUpdate";
export const wildcard2RegExp = (wildcardExp) => {
    const regExpString = wildcardExp
        .split(/\./)
        .join("\\.")
        .split(/\*+/)
        .join(".*")
        .split(/\+/)
        .join("\\+");
    return new RegExp("^" + regExpString + "$");
};
export function cleanObject(object) {
    for (const key in object) {
        delete object[key];
    }
}
export const isSamePathSubscription = (path, notification) => {
    return path === notification;
};
export const isSamePanelConfig = (config, notification) => {
    return ((isAnyUndefined(notification.mode, config.mode) ||
        config.mode === notification.mode) &&
        config.program === notification.program &&
        config.workspace === notification.workspace &&
        config.scenario === notification.scenario);
};
//# sourceMappingURL=utils.js.map